// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.participants-panel {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 100%;
  background-color: #16213e;
  border-left: 1px solid #0f3460;
}

.participants-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #0f3460;
}

.participants-header h3 {
  margin: 0;
  font-size: 18px;
  color: #eaeaea;
}

.participants-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px;
}

.participant-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  transition: background-color 0.2s;
}

.participant-item:hover {
  background-color: #0f3460;
}

.participant-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e94560 0%, #0f3460 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  color: white;
  flex-shrink: 0;
}

.participant-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.participant-name {
  font-size: 14px;
  font-weight: 500;
  color: #eaeaea;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.host-badge {
  font-size: 10px;
  padding: 2px 6px;
  background-color: #e94560;
  color: white;
  border-radius: 4px;
  width: fit-content;
}

.participant-status {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.participant-status .status-icon {
  font-size: 14px;
  opacity: 0.7;
}

@media (max-width: 768px) {
  .participants-panel {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    z-index: 1000;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
  }

  .participants-header {
    padding: 14px;
  }

  .participants-header h3 {
    font-size: 16px;
  }

  .participant-item {
    padding: 10px 12px;
  }

  .participant-avatar {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  .participant-name {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .participants-panel {
    top: 60px;
    height: calc(100vh - 60px);
  }

  .participant-item {
    padding: 8px 10px;
  }

  .participant-status .status-icon {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ParticipantsList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,WAAW;IACX,eAAe;IACf,aAAa;IACb,0CAA0C;EAC5C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;IACT,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".participants-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 300px;\r\n  height: 100%;\r\n  background-color: #16213e;\r\n  border-left: 1px solid #0f3460;\r\n}\r\n\r\n.participants-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 16px;\r\n  border-bottom: 1px solid #0f3460;\r\n}\r\n\r\n.participants-header h3 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  color: #eaeaea;\r\n}\r\n\r\n.participants-list {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 8px;\r\n}\r\n\r\n.participant-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.participant-item:hover {\r\n  background-color: #0f3460;\r\n}\r\n\r\n.participant-avatar {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  background: linear-gradient(135deg, #e94560 0%, #0f3460 100%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  color: white;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.participant-info {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.participant-name {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #eaeaea;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.host-badge {\r\n  font-size: 10px;\r\n  padding: 2px 6px;\r\n  background-color: #e94560;\r\n  color: white;\r\n  border-radius: 4px;\r\n  width: fit-content;\r\n}\r\n\r\n.participant-status {\r\n  display: flex;\r\n  gap: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.participant-status .status-icon {\r\n  font-size: 14px;\r\n  opacity: 0.7;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .participants-panel {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    z-index: 1000;\r\n    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);\r\n  }\r\n\r\n  .participants-header {\r\n    padding: 14px;\r\n  }\r\n\r\n  .participants-header h3 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .participant-item {\r\n    padding: 10px 12px;\r\n  }\r\n\r\n  .participant-avatar {\r\n    width: 32px;\r\n    height: 32px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .participant-name {\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .participants-panel {\r\n    top: 60px;\r\n    height: calc(100vh - 60px);\r\n  }\r\n\r\n  .participant-item {\r\n    padding: 8px 10px;\r\n  }\r\n\r\n  .participant-status .status-icon {\r\n    font-size: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
